import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Navbar from "../components/Navbar";
import SideBarMobile from "../components/SideBarMobile";
import { getEmployeeNavbarItems } from "./navigationItems";
import { useShowProfileQuery } from "../services/users/auth";
import { setCurrentUser } from "../app/store/reducers/authSlice";
import { useTranslation } from "react-i18next";
import { setDocumentLang } from "../utils/helpers";
import i18n from "../i18n";
import { PointsInfoProvider } from "../context/PointsInfoContext";
import { saveReturnUrl } from "../utils/authRedirect";
import GlobalAssistantWidget from "../components/GlobalAssistant/GlobalAssistantWidget";
import { getAiFeatureFlags } from "../utils/aiFeatureFlags";

const EmployeeLayout = ({ active }) => {
  const isAdmin = localStorage.getItem("is_admin") === "true";
  const { data: myProfile, error } = useShowProfileQuery(undefined, {
    skip: isAdmin,
  });
  const { t } = useTranslation(["common", "profile", "leaderboard"]);
  const { aiCompanionEnabled } = getAiFeatureFlags(
    myProfile?.data?.organization,
  );

  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (myProfile?.status == "success") {
      dispatch(setCurrentUser(myProfile?.data));
      i18n.changeLanguage(myProfile?.data?.language);
      setDocumentLang(myProfile?.data?.language);
    }

    if (error?.status == 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("is_admin");
      dispatch(setCurrentUser(null));
      saveReturnUrl(location.pathname + location.search);
      navigate("/login");
    }
  }, [myProfile, error, location.pathname, location.search, dispatch, navigate]);

  return (
    <PointsInfoProvider>
      <div className="admin-layout">
        <Navbar
          items={getEmployeeNavbarItems(active, t)}
          isAdmin={isAdmin}
          oraganizationLogo={
            myProfile?.data ? myProfile?.data?.organization?.image_url : ""
          }
        />
        <div className="container-fluid">
          <div className="row">
            <SideBarMobile items={getEmployeeNavbarItems(active, t)} />
            <div className="col content-page">
              {/* This element will render child of AdminLayout */}
              <Outlet />
            </div>
          </div>
        </div>
        {aiCompanionEnabled && <GlobalAssistantWidget />}
      </div>
    </PointsInfoProvider>
  );
};

export default EmployeeLayout;
